import React from 'react';
import { useApptekster } from '../contexts/ApptekstContext';
import classNames from 'classnames';

type PakrevdFeltProps = {
    className?: string;
};

export const PakrevdFelt: React.FC<PakrevdFeltProps> = ({ className }) => {
    const t = useApptekster();

    return (
        <p className={classNames(className)} aria-hidden>
            {t('personlig-kjennemerke.felles.pakrevd.felter')}
        </p>
    );
};
